// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-info-popup {\n  height: 270px;\n}\n.userinfo-username {\n  font-size: 3em;\n  font-weight: 600;\n}\n.userinfo-userdept {\n  font-size: 1.5em;\n  font-weight: 500;\n}\n.text-usersetting {\n  text-align: center;\n  height: 30px !important;\n}\n.text-userinfo {\n  text-align: center;\n  background-color: #dddddd;\n  border-radius: 10px;\n  padding-top: 30px !important;\n}\n.userinfo-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
